import { Signal, afterRenderEffect, computed, inject, untracked } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ScheduledCallOfferAlertService } from '../services/scheduled-call-offer-alert.service';

/** Must match the `key` of the p-toast in scheduled-call-offer-toast.component.html. */
export const SCHEDULED_CALL_OFFER_TOAST_KEY = 'scheduled-call-offer';

/**
 * State-driven offer toast (K-172): one sticky message on the host's MessageService while `visible` holds, cleared
 * when it does not. After render, so the p-toast has subscribed. Call from a host field initializer (injection context).
 * Also starts the root alarm (sound, tab mark, side-menu badge) that every toast host shares.
 */
export function bindScheduledCallOfferToast(visible: () => boolean): Signal<boolean> {
  inject(ScheduledCallOfferAlertService);
  const messageService = inject(MessageService);
  const shown = computed(visible);
  let added = false;

  afterRenderEffect(() => {
    const show = shown();
    untracked(() => {
      if (show === added) {
        return;
      }

      added = show;
      messageService.clear(SCHEDULED_CALL_OFFER_TOAST_KEY);
      if (show) {
        messageService.add({
          key: SCHEDULED_CALL_OFFER_TOAST_KEY,
          severity: 'info',
          sticky: true,
          closable: false,
        });
      }
    });
  });

  return shown;
}
